import { PopoutSource } from './datapoints';
export { PopoutSource };
import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "Popouts" */ './lazyIndex');
});
// Lazy-load components
export var PopoutContainer = createLazyComponent(lazyModule, function (m) { return m.PopoutContainer; });
//# sourceMappingURL=index.js.map